import { Loader, Table } from '@mantine/core';

const LoadingState = () => (
    <Table.Tr>
        <Table.Td className="py-20 text-center" colSpan={100}>
            <Loader color="dark" />
        </Table.Td>
    </Table.Tr>
);

export default LoadingState;
